export const userSettingsConstants = {
    USER_SETTINGS_UPDATE: 'USER_SETTINGS_UPDATE'
};
